
import { defineComponent, ref, onMounted, computed } from 'vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { Kamoku } from '@/repositories/fuzoku-meisai/data'
import { kaikeikijunRepositories } from '@/repositories/fuzoku-meisai/kaikei-kijun/kaikeikijunRepositories'
import { callApiWrapper } from '@/views/callApiWrapper'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'
import { KariirekinUiItem } from '@/views/fuzoku-meisai/kaikei-kijun/data'
import { UiItemsLogic } from '@/views/fuzoku-meisai/uiItemsLogic'
import KariirekinSettingItem from '@/views/fuzoku-meisai/kaikei-kijun/KariirekinSettingItem.vue'
import KaikeiKijunSettingTitle from '@/views/fuzoku-meisai/kaikei-kijun/KaikeiKijunSettingTitle.vue'

const repository = kaikeikijunRepositories.kariirekin

export default defineComponent({
  components: {
    KaikeiKijunSettingTitle,
    KariirekinSettingItem,
    ResponseResultAlert,
    ContentLayout,
    LoadingButton
  },
  setup () {
    let kamokuSource: Kamoku[] = []
    const loading = ref(false)
    const isSucceedRequest = ref(false)
    const requestError = ref<string | null>(null)
    const items = ref<KariirekinUiItem[]>([])
    const isAllValid = computed(() => {
      const allCount = items.value.length
      if (allCount === 0) {
        return true
      }
      return allCount === items.value.filter(i => i.isValid).length
    })

    onMounted(async () => {
      loading.value = true
      await callApiWrapper(requestError, async () => {
        const data = await repository.list()
        kamokuSource = data.kamokuSources
        items.value = data.items.map(value => ({ item: value, isValid: true }))
      })
      loading.value = false
    })

    const onClickRegister = async () => {
      loading.value = true
      onDismissAlert()

      await callApiWrapper(requestError, async () => {
        const params = items.value.map(v => v.item)
        await repository.save(params)
        const data = await repository.list()
        kamokuSource = data.kamokuSources
        items.value = data.items.map(value => ({ item: value, isValid: true }))
        isSucceedRequest.value = true
      })
      loading.value = false
    }

    const onDismissAlert = () => {
      isSucceedRequest.value = false
      requestError.value = null
    }

    const addItem = () => {
      const newId = UiItemsLogic.makeId(items.value)
      items.value.push({
        isValid: false,
        item: {
          id: newId,
          itemName: '',
          interestRate: 0,
          repaymentDeadline: '',
          settings: {
            sources: kamokuSource,
            targets: []
          }
        }
      })
    }

    const upItem = (item: KariirekinUiItem) => UiItemsLogic.upUiItem(items.value, item)

    const downItem = (item: KariirekinUiItem) => UiItemsLogic.downUiItem(items.value, item)

    const trashItem = (item: KariirekinUiItem) => UiItemsLogic.removeUiItem(items.value, item)

    const onChangeInput = (item: KariirekinUiItem) => UiItemsLogic.updateUiItem(items.value, item)

    return {
      loading,
      isAllValid,
      isSucceedRequest,
      requestError,
      items,
      onClickRegister,
      onDismissAlert,
      addItem,
      upItem,
      downItem,
      trashItem,
      onChangeInput
    }
  }
})
